import { useDispatch } from "react-redux";
import { message } from "antd";
import { updateFinalizeStatus } from "../actions/createDP";
import { getFinalizeStatus, patchFinalizeStatus } from "../utils/ajax-proxy";

export function useMarkAsCompleteHooks() {
  const dispatch = useDispatch();

  const trial_uuid = localStorage.getItem("trial-id");

  const getSectionLockStatus = () => {
    getFinalizeStatus(trial_uuid)
      .then((res) => {
        dispatch(updateFinalizeStatus(res));
      })
      .catch((e) => {})
      .finally(() => {});
  };

  const doLockOrUnlock = async (payload: any, isLock: boolean) => {
    const operation = isLock ? "lock" : "unlock";
    try {
      const res = await patchFinalizeStatus({
        ...payload,
        trial_uuid,
      });
      if (res.error) {
        message.error(`Failed to ${operation}.`);
      } else {
        // refresh status
        getSectionLockStatus();
        message.success(`${operation}ed successfully.`);
      }
    } catch (error) {
      message.error(`Failed to ${operation}.`);
    }
  };

  return {
    getSectionLockStatus,
    doLockOrUnlock,
  };
}
